module.exports = __webpack_public_path__ + "static/img/WechatIMG472.8449288.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WechatIMG472.jpg
// module id = OHPa
// module chunks = 1